import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "new_components/Development/Development.scss";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";

import axios from "axios";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";

import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
import ComingSoon from "new_assets/new_images/Builders/coming_soon.png";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
//import PreLoad from "new_components/PreLoad/PreLoad";
import HomeBottomBanner from "new_components/Home/HomeBottomBanner";
const Development = () => {
  return (
    <>
      <ScrollToTopDefault />
      <ProgressCircle />
      <Header />
      <Body />
      <Footer />
    </>
  );
};
const Body = () => {
  return (
    <div>
      <DevelopmentBanner />
      <InvestmentStrategy />
      <VideoTour />
      <InvestmentOpportunities />
      <section className="flat-section pb-0">
        <div className="container py-5 bg-primary-new">
          <div className=" box-title wow fadeInUp closedInv">
            <h3 className="title text-uppercase">Open to new investors</h3>
          </div>
          <OpenToInvestors />
        </div>
      </section>
      {/* <section className="flat-section pb-0">
        <div className="container py-5 bg-primary-new">
          <div className=" box-title wow fadeInUp closedInv">
            <h3 className="title text-uppercase">Closed to New Investors</h3>
          </div>
          <ClosedToInvestors />
        </div>
      </section> */}
      <ClosedToInvestors />
      <HomeBottomBanner />
      {/* <QuoteSection /> */}
    </div>
  );
};

const ClosedToInvestors = () => {
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const itemsPerPage = 4;

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(apiUrls.propertiesCloseInv);
        if (response.data.status === "success") {
          // Filter only active properties
          const activeProperties = response.data.data.filter(
            (property) => property.is_active === true,
          );
          setProperties(activeProperties);
        } else {
          setError("Failed to fetch properties.");
        }
      } catch (err) {
        setError("An error occurred while fetching data.");
      }
    };

    fetchProperties();
  }, []);

  const totalPages = Math.ceil(properties.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProperties = properties.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  if (!error && properties.length === 0) return null;
  return (
    <section className="flat-section pb-0">
      <div className="container py-5 bg-primary-new">
        <div className=" box-title wow fadeInUp closedInv">
          <h3 className="title text-uppercase">Closed to New Investors</h3>
        </div>
        <section className="completed-projects">
          <div>
            {error ? (
              <div className="text-center coming-soon note body-2 row px-md-4">
                <div className="col">
                  <img
                    src={ComingSoon}
                    alt="Coming Soon"
                    className="w-75 float-md-start"
                  />
                </div>
                <div className="col align-content-around">
                  <h3>Coming Soon</h3>
                </div>
              </div>
            ) : currentProperties.length > 0 ? (
              currentProperties.map((property) => (
                <div key={property.id} className="row mb-5 closedprop bg-white">
                  <div className="buildercompletedprojectshero col-12 col-md-4 col-xl-2 text-center">
                    <img
                      src={Image_Base_URL + property.image}
                      alt={property.title || "Property Image"}
                      className="project-image"
                    />
                  </div>

                  <div className=" col-12 col-md-8 col-xl-10 p-md-3 pl-lg-4 pb-2">
                    <div className="row  body-2 fw-bold pb-2 pt-1">
                      <div className="col">{property.title}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Sq Ft Under AC:{" "}
                        <span className="fw-bold">
                          {property.sq_ft_under_ac || "null"}
                        </span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Sq Ft Exterior Living:{" "}
                        <span className="fw-bold">
                          {property.sq_ft_exterior_living || "null"}
                        </span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        SqFt Garage:{" "}
                        <span className="fw-bold">
                          {property.sq_ft_garage || "null"}
                        </span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Each Unit SqFt:{" "}
                        <span className="fw-bold">
                          {property.each_unit_sqft || "null"}
                        </span>
                      </div>
                      <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                        Total Property:{" "}
                        <span className="fw-bold">
                          {property.total_property || "null"}
                        </span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: property.description,
                        }}
                      />
                    </div>
                    <div className="row pt-1 fw-bold">
                      {property.amenities.map((amenity, index) => (
                        <div
                          key={index}
                          className=" col-12 col-lg-6 col-xl-4 pb-md-2 pb-1"
                        >
                          {amenity}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center coming-soon note body-2 row px-md-4">
                <div className="col">
                  <img
                    src={ComingSoon}
                    alt="Coming Soon"
                    className="w-75 float-md-start"
                  />
                </div>
                <div className="col align-content-around">
                  <h3>Coming Soon</h3>
                </div>
              </div>
            )}
          </div>
          {currentProperties.length > 0 && !error && totalPages > 1 && (
            <div className="pagination-controls text-center">
              <button
                className="btn"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                className="btn"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </section>
      </div>
    </section>
  );
};

const OpenToInvestors = () => {
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const itemsPerPage = 4;

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(apiUrls.propertiesOpenInv);
        if (response.data.status === "success") {
          // Filter only active properties
          const activeProperties = response.data.data.filter(
            (property) => property.is_active === true,
          );
          setProperties(activeProperties);
        } else {
          setError("Failed to fetch properties. Please try again later.");
        }
      } catch (err) {
        setError("An error occurred while fetching the properties.");
      }
    };

    fetchProperties();
  }, []);

  const totalPages = Math.ceil(properties.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProperties = properties.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);
  const prevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  return (
    <section className="completed-projects">
      <div>
        {error ? (
          <div className="text-center coming-soon note body-2 row px-md-4">
            <div className="col">
              <img
                src={ComingSoon}
                alt="Coming Soon"
                className="w-75 float-md-start"
              />
            </div>
            <div className="col align-content-around">
              <h3>Coming Soon</h3>
            </div>
          </div>
        ) : currentProperties.length > 0 ? (
          currentProperties.map((property) => (
            <div key={property.id} className="row mb-5 closedprop bg-white">
              <div className="buildercompletedprojectshero col-12 col-md-4 col-xl-2 text-center">
                <img
                  src={Image_Base_URL + property.image}
                  alt={property.title || "Property Image"}
                  className="project-image"
                />
              </div>

              <div className=" col-12 col-md-8 col-xl-10 p-md-3 pl-lg-4 pb-2">
                <div className="row  body-2 fw-bold pb-2 pt-1">
                  {/* <div className="col-12 col-sm-4  col-xl-2"> */}
                  <div className="col-12 col-sm-auto">
                    <span className="badge bg-success rounded-pill mb-1">
                      {property.comingSoon}
                    </span>
                  </div>
                  <div className="col">{property.title}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                    Sq Ft Under AC:{" "}
                    <span className="fw-bold">
                      {property.sq_ft_under_ac || "null"}
                    </span>
                  </div>
                  <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                    Sq Ft Exterior Living:{" "}
                    <span className="fw-bold">
                      {property.sq_ft_exterior_living || "null"}
                    </span>
                  </div>
                  <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                    SqFt Garage:{" "}
                    <span className="fw-bold">
                      {property.sq_ft_garage || "null"}
                    </span>
                  </div>
                  <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                    Each Unit SqFt:{" "}
                    <span className="fw-bold">
                      {property.each_unit_sqft || "null"}
                    </span>
                  </div>
                  <div className="col-12 col-sm-6 col-xl-3 pb-md-2 pb-1">
                    Total Property:{" "}
                    <span className="fw-bold">
                      {property.total_property || "null"}
                    </span>
                  </div>
                </div>
                <div className="row mb-2">
                  <div
                    dangerouslySetInnerHTML={{ __html: property.description }}
                  />
                </div>
                <div className="row pt-1 fw-bold">
                  {property.amenities.map((amenity, index) => (
                    <div
                      key={index}
                      className=" col-12 col-lg-6 col-xl-4 pb-md-2 pb-1"
                    >
                      {amenity}
                    </div>
                  ))}
                </div>
                <div className="row mt-3">
                  <div className="col"></div>

                  {/* Only render this col if BOTH button_text and button_url exist */}
                  {property.button_text && property.button_url && (
                    <div className="col-auto">
                      <a
                        href={property.button_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn rounded-pill fw-bold body-2 pm-btn primary"
                      >
                        {property.button_text}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center coming-soon note body-2 row px-md-4">
            <div className="col">
              <img
                src={ComingSoon}
                alt="Coming Soon"
                className="w-75 float-md-start"
              />
            </div>
            <div className="col align-content-around">
              <h3>Coming Soon</h3>
            </div>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div className="pagination-controls text-center">
          <button
            className="btn"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <button
            className="btn"
            onClick={nextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </section>
  );
};
const DevelopmentBanner = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const Preload = () => {
    return (
      <div className="preload preload-container">
        <div className="preload-logo">
          <div className="spinner" />
          <span className="icon icon-villa-fill" />
        </div>
      </div>
    );
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.developmentBanner);
        if (
          response.data?.status === "success" &&
          response.data?.data?.length
        ) {
          setData(response.data.data[0]);
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div>
        <Preload />
      </div>
    );
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <section className="flat-section">
      <div className="container">
        <div
          className="row align-items-center justify-content-center wow fadeInUp developmentbanner mx-md-5 px-1 px-md-5"
          style={{
            backgroundImage: `url(${Image_Base_URL + data.image})`,
          }}
          data-wow-delay=".2s"
        >
          <div className="col-12 text-center">
            <p className="subtitle text-white body-2 wow fadeInUp">
              {data?.title1 || "Welcome to"}{" "}
            </p>
            <h3 className="title text-white">
              {data?.title2 || "LUCKY DUCK DEVELOPMENT"}
            </h3>
          </div>
          <div className="col-12 align-items-left">
            <p
              className="subtitle text-white body-2 wow fadeInUp px-5"
              dangerouslySetInnerHTML={{
                __html: data?.description || "No Description",
              }}
            ></p>

            <button
              className="tf-btn btn-view primary hover-btn-view ml-5 mt-3"
              onClick={() => {
                const url = new URL("/contact-us", window.location.origin);

                window.location.href = url.toString();
              }}
            >
              {data.button_text || "Contact Us"}{" "}
              <span className="icon icon-arrow-right2"></span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
const InvestmentStrategy = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.investmentStrategy);
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          setData(response.data.data[0]); // Get the first object from the data array
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <section className="flat-section bg-primary-new">
      <div className="container">
        <div className="box-title text-center wow fadeInUp">
          <h3 className="mt-4 title">{data.title}</h3>
        </div>
        <div
          className="row align-items-center justify-content-center wow fadeInUp"
          data-wow-delay=".2s"
        >
          <div className="col-12 col-md-4 text-center mb-2 dev-invest">
            <img
              src={`${Image_Base_URL}${data.image}`}
              alt="Investment strategy illustration"
            />
          </div>
          <div className="col-12 col-md-8">
            <div
              className="investmentphildata note body-2"
              dangerouslySetInnerHTML={{ __html: data.description }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const VideoTour = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Extract and normalize YouTube embed URL from different formats
  const getYouTubeEmbedUrl = (url) => {
    try {
      if (!url) return null;

      const parsedUrl = new URL(url);
      const hostname = parsedUrl.hostname;
      let videoId = null;

      // Format 1: https://www.youtube.com/watch?v=VIDEO_ID
      if (hostname.includes("youtube.com") && parsedUrl.searchParams.has("v")) {
        videoId = parsedUrl.searchParams.get("v");
      }

      // Format 2: https://www.youtube.com/embed/VIDEO_ID
      else if (
        hostname.includes("youtube.com") &&
        parsedUrl.pathname.startsWith("/embed/")
      ) {
        videoId = parsedUrl.pathname.split("/embed/")[1];
      }

      // Format 3: https://youtu.be/VIDEO_ID
      else if (hostname === "youtu.be") {
        videoId = parsedUrl.pathname.slice(1);
      }

      if (!videoId) return null;

      // Construct final embed URL with desired params
      return `https://www.youtube.com/embed/${videoId}?loop=1&playlist=${videoId}&rel=0&modestbranding=1`;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.videoTour);
        if (
          response.data?.status === "success" &&
          Array.isArray(response.data.data)
        ) {
          const activeVideo = response.data.data.find(
            (video) => video.is_active,
          );
          if (activeVideo) {
            setData(activeVideo);
          }
        }
      } catch (err) {
        // Fail silently – do not render
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Only render if we have a valid, active video
  if (loading || !data || !data.is_active) {
    return null;
  }

  const embedUrl = getYouTubeEmbedUrl(data.yt_video_link);
  if (!embedUrl) return null;

  return (
    <section className="flat-section pb-0 pt-0">
      <div className="container py-5 pb-0">
        <div className="box-title wow fadeInUp videoDev">
          <h3 className="title text-uppercase">{data.section_title}</h3>
        </div>
        <div className="row mb-5">
          <div className="col-12 mx-auto" style={{ maxWidth: "800px" }}>
            {/* Enhanced responsive video container */}
            <div className="ratio ratio-16x9 rounded-4 overflow-hidden shadow-sm">
              <iframe
                src={embedUrl}
                title="YouTube video"
                className="w-100 h-100"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const InvestmentOpportunities = () => {
  const [investmentData, setInvestmentData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.callToAction);
        setInvestmentData(response.data.data); // Access the "data" array from the response
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch investment opportunities.");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <section className="row dualbannerinvrow">
      {investmentData.map((item) => (
        <React.Fragment key={item.id}>
          <div className="col-12 col-md-6 dualbannerinvone">
            <h6 className="title text-white">{item.title}</h6>
            {item.sub_title && (
              <p className="body-2 text-white">{item.sub_title}</p>
            )}
            {/* Only show the break and button if both link and text exist */}
            {item.button_link && item.button_text && (
              <>
                <br />
                <Link
                  to={item.button_link}
                  className="tf-btn btn-view primary hover-btn-view ml-5 dualbannerinvonebtn"
                >
                  {item.button_text}{" "}
                  <span className="icon icon-arrow-right2 dualbannerinvonebtnicon"></span>
                </Link>
              </>
            )}
          </div>

          <div
            className="col-12 col-md-6 dualbannerinvsecpic"
            style={{
              backgroundImage: `url(${Image_Base_URL}${item.image})`, // Dynamically set background image
            }}
          ></div>
        </React.Fragment>
      ))}
    </section>
  );
};

// const QuoteSection = () => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(apiUrls.bottomBanner);
//         if (
//           response.data.status === "success" &&
//           response.data.data.length > 0
//         ) {
//           setData(response.data.data[0]);
//         } else {
//           throw new Error(
//             "Invalid API response structure or no data available."
//           );
//         }
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="text-center">
//         <PreLoad />
//       </div>
//     );
//   }

//   if (error) {
//     return <div className="text-center text-danger">Error: {error}</div>;
//   }

//   return (
//     <section className="flat-section">
//       <div className="container">
//         <div
//           className="row align-items-center justify-content-center wow fadeInUp ldgquote mx-md-5"
//           data-wow-delay=".2s"
//           style={{ backgroundImage: `url(${Image_Base_URL}${data.bg_image})` }}
//         >
//           <div className="col-12 text-center">
//             <h3 className="title text-white">
//               {data?.title || "Title not available"}
//             </h3>
//             <div className="note body-2 text-white pt-2">
//               {data?.footer_text || "Description not available"}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

export default Development;
